exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".modal-body[data-v-8bf8c0b6]{padding:unset}[type=checkbox]:checked+label[data-v-8bf8c0b6]:before{width:unset;height:unset}", ""]);

// exports
